export const SERVER: string = 'https://api.anilpan.com.mx';
